// Func created for create and get session for each click as array
const saveTabDataToSessionStorage = (selectedTabData, tabSessionName) => {
  let setTabArray = [];
  // Parse the serialized data back into an aray of objects
  setTabArray = JSON.parse(window.sessionStorage.getItem(tabSessionName)) || [];
  // Push the new data (whether it be an object or anything else) onto the array
  setTabArray.push(selectedTabData);
  // Re-serialize the array back into a string and store it in sessionStorage
  window.sessionStorage.setItem(tabSessionName, JSON.stringify(setTabArray));
};
const getTabDataToSessionStorage = (getTabSeesion) => {
  const newdata = JSON.parse(window.sessionStorage.getItem(getTabSeesion));
  console.log(newdata);
  const last = newdata.slice(-1)[0];
  console.log('BucketTabSession last value ++++++', last);
  return newdata;
};

export { saveTabDataToSessionStorage, getTabDataToSessionStorage };
